// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutUs_wrapper__dJmTf {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 100px;
  padding-top: 50px;
  gap: 100px;
}

.AboutUs_h1__aR3lv,
.AboutUs_text__ze344 {
  padding-bottom: 15px;
}

.AboutUs_h1__aR3lv {
  font-size: 36px;
  font-weight: 800;
  font-family: "Lato";
}

.AboutUs_text__ze344 {
  font-weight: 400;
  font-size: 16px;
  font-family: "Open Sans";
  color: rgb(0, 0, 0, 0.5);
}

.AboutUs_left__2E4eY {
  width: 30%;
}

.AboutUs_right__C2DX1 {
  width: 30%;
  padding-top: 25px;
  display: grid;
  grid-template-rows: 45px 160px 55px 110px 55px;
  grid-template-columns: 1fr 1.5fr;
  grid-gap: 15px;
}

.AboutUs_griditem1__fqA4Q {
  grid-row: 1/4;
  grid-column: 1/2;
}

.AboutUs_griditem2__6jnIh {
  grid-row: 2/3;
  grid-column: 2/3;
}
.AboutUs_griditem3__5ITYo {
  grid-row: 3/5;
  grid-column: 2/3;
}

.AboutUs_griditem4__f2Lyh {
  grid-row: 4/6;
  grid-column: 1/2;
}

.AboutUs_griditem1__fqA4Q img,
.AboutUs_griditem2__6jnIh img,
.AboutUs_griditem3__5ITYo img,
.AboutUs_griditem4__f2Lyh img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.AboutUs_btn__YT5mM {
  padding: 16px 24px 16px 24px;
  border-radius: 8px;
  border: none;
  gap: 8px;
  background-color: #47a9f4;
  width: 70%;
  margin-top: 20px;
}

.AboutUs_btn__YT5mM:hover {
  cursor: pointer;
  background-color: #3175a8;
}

.AboutUs_btnText__bBdZx {
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: center;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.AboutUs_btn__YT5mM:hover {
  cursor: pointer;
}

@media screen and (max-width: 1350px) {
  .AboutUs_right__C2DX1 {
    min-width: 450px;
  }
}

@media screen and (max-width: 1200px) {
  .AboutUs_right__C2DX1,
  .AboutUs_left__2E4eY {
    min-width: 400px;
  }
  .AboutUs_wrapper__dJmTf {
    flex-direction: column;
  }
  .AboutUs_btn__YT5mM {
    width: 100%;
  }
}

@media screen and (max-width: 500px) {
  .AboutUs_h1__aR3lv {
    font-size: 32px;
  }
  .AboutUs_text__ze344 {
    font-size: 15px;
  }
  .AboutUs_left__2E4eY,
  .AboutUs_right__C2DX1 {
    min-width: 350px;
  }
}

@media screen and (max-width: 410px) {
  .AboutUs_left__2E4eY,
  .AboutUs_right__C2DX1 {
    min-width: 300px;
  }
}

@media screen and (max-width: 345px) {
  .AboutUs_left__2E4eY,
  .AboutUs_right__C2DX1 {
    min-width: 270px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/AboutUs/AboutUs.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,8CAA8C;EAC9C,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":[".wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 100px;\n  padding-top: 50px;\n  gap: 100px;\n}\n\n.h1,\n.text {\n  padding-bottom: 15px;\n}\n\n.h1 {\n  font-size: 36px;\n  font-weight: 800;\n  font-family: \"Lato\";\n}\n\n.text {\n  font-weight: 400;\n  font-size: 16px;\n  font-family: \"Open Sans\";\n  color: rgb(0, 0, 0, 0.5);\n}\n\n.left {\n  width: 30%;\n}\n\n.right {\n  width: 30%;\n  padding-top: 25px;\n  display: grid;\n  grid-template-rows: 45px 160px 55px 110px 55px;\n  grid-template-columns: 1fr 1.5fr;\n  grid-gap: 15px;\n}\n\n.griditem1 {\n  grid-row: 1/4;\n  grid-column: 1/2;\n}\n\n.griditem2 {\n  grid-row: 2/3;\n  grid-column: 2/3;\n}\n.griditem3 {\n  grid-row: 3/5;\n  grid-column: 2/3;\n}\n\n.griditem4 {\n  grid-row: 4/6;\n  grid-column: 1/2;\n}\n\n.griditem1 img,\n.griditem2 img,\n.griditem3 img,\n.griditem4 img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.btn {\n  padding: 16px 24px 16px 24px;\n  border-radius: 8px;\n  border: none;\n  gap: 8px;\n  background-color: #47a9f4;\n  width: 70%;\n  margin-top: 20px;\n}\n\n.btn:hover {\n  cursor: pointer;\n  background-color: #3175a8;\n}\n\n.btnText {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: 0px;\n  text-align: center;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n.btn:hover {\n  cursor: pointer;\n}\n\n@media screen and (max-width: 1350px) {\n  .right {\n    min-width: 450px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .right,\n  .left {\n    min-width: 400px;\n  }\n  .wrapper {\n    flex-direction: column;\n  }\n  .btn {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .h1 {\n    font-size: 32px;\n  }\n  .text {\n    font-size: 15px;\n  }\n  .left,\n  .right {\n    min-width: 350px;\n  }\n}\n\n@media screen and (max-width: 410px) {\n  .left,\n  .right {\n    min-width: 300px;\n  }\n}\n\n@media screen and (max-width: 345px) {\n  .left,\n  .right {\n    min-width: 270px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `AboutUs_wrapper__dJmTf`,
	"h1": `AboutUs_h1__aR3lv`,
	"text": `AboutUs_text__ze344`,
	"left": `AboutUs_left__2E4eY`,
	"right": `AboutUs_right__C2DX1`,
	"griditem1": `AboutUs_griditem1__fqA4Q`,
	"griditem2": `AboutUs_griditem2__6jnIh`,
	"griditem3": `AboutUs_griditem3__5ITYo`,
	"griditem4": `AboutUs_griditem4__f2Lyh`,
	"btn": `AboutUs_btn__YT5mM`,
	"btnText": `AboutUs_btnText__bBdZx`
};
export default ___CSS_LOADER_EXPORT___;
